import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { fontSize, lineHeight } from "../../constants/typography";
import mediaQueries from "../../util/mediaqueries";
import { transparent } from "../../constants/colors";
import styled, { css } from 'styled-components';
import { MEGA_MENU_Z_INDEX } from "../mega-menu/constants";
import { DISPLAY_TYPE } from "./constants";
export var StyledContainer = styled.div.withConfig({
  componentId: "sc-zrt8vy-0"
})(["background-color:", ";color:", ";padding:16px;font-size:", ";line-height:", ";display:flex;align-items:center;gap:16px;", ""], function (_ref) {
  var $backgroundColor = _ref.$backgroundColor;
  return $backgroundColor;
}, function (_ref2) {
  var $color = _ref2.$color;
  return $color;
}, fontSize.xSmall, lineHeight.medium, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n    padding: 24px;\n    gap: 24px;\n "])), 0, 0)), fontSize.small, lineHeight.large));
export var StyledDismissContainer = styled.button.withConfig({
  componentId: "sc-zrt8vy-1"
})(["cursor:pointer;background-color:", ";border:none;svg{height:9px;width:9px;", "}"], transparent, mediaQueries.sm(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 13px;\n    width: 13px;\n  "]))))));
export var StyledBannerContainer = styled.div.withConfig({
  componentId: "sc-zrt8vy-2"
})(["text-align:", ";", ""], function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign;
}, function (_ref4) {
  var displayType = _ref4.displayType;
  if (displayType === DISPLAY_TYPE.STICKY) {
    return css(["position:sticky;top:0;z-index:", ";"], MEGA_MENU_Z_INDEX + 1);
  }
  return css(["position:relative;z-index:", ";"], MEGA_MENU_Z_INDEX + 1);
});